//For adding bundled products to cart in one step 
(function() { 
       
  var postData;

  function initBundleButton() {
    var bundleButtonListeners = document.getElementsByClassName("add-bundle");
    if (bundleButtonListeners) {
      for (i = 0; i < bundleButtonListeners.length; i++) {
          bundleButtonListeners[i].addEventListener("click", addBundleToCart);
          bundleButtonListeners[i].id= "bundleButton-"+i;
        }
    }      
  }
  
  function getBundledProducts(elementId) {
              
      var bundledProducts = [];
      var formElements = document.getElementById(elementId).elements;
      for (i = 0; i < formElements.length; i++) {
          if(formElements[i].value == ""){
              continue;
          }
          
          var singleBundleProduct = {quantity: 1, id: formElements[i].value};
          bundledProducts.push(singleBundleProduct);
        } 
      postData = {items: bundledProducts};
  }

  function addBundleToCart() { 
      var submitButton = document.getElementById(this.id);
      var elementId = submitButton.value;
      submitButton.disabled = true;
      getBundledProducts(elementId);
    
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: postData,
      dataType: 'json',
      success: function(response) {
        window.location = '/cart';
      },
      error: function(response) {
        console.log(response);
        submitButton.disabled = false;
      }
    });
  }
  
  if (document.readyState === "complete" || document.readyState === "loaded") {
      initBundleButton();
      
  } else {
    document.addEventListener("DOMContentLoaded", initBundleButton);
  }

})();

